import { useContext } from 'react';
import CardContext from './CardContext';
import { CardProviderInterface } from './types';

export default function useProgressPercent():CardProviderInterface{
  return useContext(CardContext)
};